module.exports = __webpack_public_path__ + "img/6.5f961d55.png";